module.exports = __webpack_public_path__ + "static/media/next-innovations.03d4b04c.png";